const ensureMetaTag = (type, key, value) => {
  const selector = `meta[${type}="${key}"]`;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(type, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
};

const ensureLinkTag = (selector, attributes) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("link");
    document.head.appendChild(tag);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    tag.setAttribute(key, value);
  });
};

const normalizeCanonicalUrl = (canonicalPath) => {
  if (!canonicalPath) return window.location.href;
  if (String(canonicalPath).startsWith("http")) return canonicalPath;
  return `${window.location.origin}${canonicalPath}`;
};

export const applySeoTags = ({
  title,
  description,
  canonicalPath,
  imageUrl,
}) => {
  const nextTitle = title || document.title;
  const nextDescription = description || "Dimerse dashboard";
  const canonicalUrl = normalizeCanonicalUrl(canonicalPath || window.location.pathname);
  const ogImage = imageUrl || `${window.location.origin}/branding/dimerse-logo.png`;

  document.title = nextTitle;

  ensureMetaTag("name", "description", nextDescription);
  ensureMetaTag("property", "og:title", nextTitle);
  ensureMetaTag("property", "og:description", nextDescription);
  ensureMetaTag("property", "og:type", "website");
  ensureMetaTag("property", "og:url", canonicalUrl);
  ensureMetaTag("property", "og:image", ogImage);
  ensureMetaTag("name", "twitter:card", "summary_large_image");
  ensureMetaTag("name", "twitter:title", nextTitle);
  ensureMetaTag("name", "twitter:description", nextDescription);
  ensureMetaTag("name", "twitter:image", ogImage);

  let canonical = document.head.querySelector('link[rel="canonical"][data-dynamic="true"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    canonical.setAttribute("data-dynamic", "true");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", canonicalUrl);

  ensureLinkTag('link[rel="icon"][data-dynamic="true"]', {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "/favicon-32x32.png",
    "data-dynamic": "true",
  });
  ensureLinkTag('link[rel="shortcut icon"][data-dynamic="true"]', {
    rel: "shortcut icon",
    href: "/favicon-32x32.png",
    "data-dynamic": "true",
  });
};
